import React, { useState, useEffect } from "react";
import { bookingService } from "../services/api";
import "./BookingPage.css";

const BookingPage = () => {
  const [formData, setFormData] = useState({
    contact: "",
    notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.contact || !formData.notes) {
      setError("Vui lòng điền Số điện thoại/Email và Nội dung cần tư vấn.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      await bookingService.createBooking({
        contact: formData.contact,
        notes: formData.notes,
      });
      setSuccess(true);
      setFormData({ contact: "", notes: "" });
    } catch (err) {
      setError("Đã xảy ra lỗi khi gửi yêu cầu. Vui lòng thử lại sau.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="booking-page">
      <div className="booking-hero">
        <div className="booking-hero-content">
          <h1>LIÊN HỆ TƯ VẤN MUA XE</h1>
          <p>
            Mình là một công chức, đã mua xe của Vinfast để đi làm. Mình tư vấn
            và hỗ trợ bạn mua xe để nhận hoa hồng thôi ạ. Nên mình hiểu và sẽ hỗ
            trợ để bạn được giá tốt nhất có thể, để cả hai cùng có lợi ích.
          </p>
        </div>
      </div>

      <div className="booking-container">
        <div className="booking-grid">
          {/* Contact Information */}
          <div className="contact-info-card">
            <h3>Thông tin liên hệ</h3>
            <div className="info-list">
              <div className="info-item">
                <span className="info-icon">👤</span>
                <div>
                  <p className="info-label">Họ và tên</p>
                  <p className="info-value">Bùi Thành Trung</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon">📞</span>
                <div>
                  <p className="info-label">Số điện thoại</p>
                  <p className="info-value highlight">0984 472 080</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon">✉️</span>
                <div>
                  <p className="info-label">Email</p>
                  <p className="info-value">luatgiabuithanhtrung@gmail.com</p>
                </div>
              </div>

              <div className="info-item">
                <span className="info-icon">📍</span>
                <div>
                  <p className="info-label">Địa chỉ</p>
                  <p className="info-value">
                    Phường Trung Mỹ Tây, TP Hồ Chí Minh
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-features">
              <div className="cf-item">✓ Tư vấn giá tốt nhất</div>
              <div className="cf-item">✓ Hỗ trợ vay ngân hàng</div>
              <div className="cf-item">✓ Giao xe tận nơi</div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="booking-form-card">
            <h3>Gửi yêu cầu tư vấn</h3>
            <p className="form-subtitle">
              Hãy để lại thông tin, mình sẽ liên hệ lại với bạn.
            </p>

            {success ?
              <div className="success-message">
                <div className="success-icon">✅</div>
                <h4>Gửi yêu cầu thành công!</h4>
                <p>
                  Cảm ơn bạn đã quan tâm. Chúng tôi sẽ liên hệ lại với bạn trong
                  thời gian sớm nhất.
                </p>
                <button
                  className="btn btn-outline"
                  onClick={() => setSuccess(false)}
                  style={{ marginTop: "20px" }}
                >
                  Gửi yêu cầu khác
                </button>
              </div>
            : <form onSubmit={handleSubmit} className="booking-form">
                {error && <div className="error-message">{error}</div>}

                <div className="form-group">
                  <label>Số điện thoại hoặc Email *</label>
                  <input
                    type="text"
                    name="contact"
                    value={formData.contact}
                    onChange={handleInputChange}
                    placeholder="Nhập SĐT hoặc Email của bạn"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Nội dung cần tư vấn *</label>
                  <textarea
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    placeholder="Bạn quan tâm dòng xe nào? Nhận báo giá lăn bánh, tư vấn trả góp..."
                    rows="5"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary submit-btn"
                  disabled={loading}
                >
                  {loading ? "Đang gửi..." : "Gửi Yêu Cầu"}
                </button>
              </form>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
